<template>
  <Teleport to="body">
    <div v-if="visible" class="quota-mask" @click.self="handleClose">
      <div class="quota-dialog">
        <div class="quota-qr-code">
          <img src="../assets/quota_qrcode.jpg">
          <div class="quota-qr-code-right-tips">
            <div class="quota-text">配额不足,请输入兑换码</div>
            <div class="quota-sub-text">扫码联系客服</div>
          </div>
        </div>
        <div class="quota-btn-container">
          <button class="quota-button" type="button" @click="handleClose">
            好的
          </button>
          <button class="quota-button quota-code-input-btn" type="button" @click="handleRedeemShow">
            输入兑换码
          </button>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
/* global defineProps, defineEmits */
import { emitExchangeRequired } from '@/utils/exchangeModalBus';

defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['close','redeemShow']);

const handleClose = () => {
  emit('close');
};

const handleRedeemShow = () => {
  // 关闭当前配额提示
  emit('close');
  // 通知父组件（如果有监听）
  emit('redeemShow');
  // 触发头部兑换码弹窗
  emitExchangeRequired();
};
</script>

<style scoped>
.quota-mask {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1300;
  pointer-events: none;
}

.quota-dialog {
  pointer-events: auto;
  width: 350px;
  padding: 24px 24px 20px;
  border-radius: 16px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 24px;
  color: #ffffff;
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.6);
  border: 1px solid #FFF;
  background: rgba(27, 24, 19, .9);
}

.quota-btn-container {
  display: flex;
  gap: 20px;
}

.quota-qr-code-right-tips {
  margin-left: 10px;
}

.quota-sub-text {
  font-size: 16px;
  font-weight: 400;
  color: #999999;
}

.quota-text {
  margin-bottom: 5px;
  color: #FFF;
  font-feature-settings: 'liga' off, 'calt' off;
  font-family: "PingFang SC";
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 32px; /* 160% */
}

.quota-qr-code {
  display: flex;
  align-items: center;
}

.quota-qr-code img {
  width: 80px;
  height: 80px;
  border-radius: 2px;
}

.quota-button {
  width: 100%;
  height: 44px;
  border-radius: 8px;
  border: none;
  background: #4a4136;
  color: #ffffff;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.15s ease, transform 0.1s ease;
}

.quota-button:hover {
  opacity: 0.9;
}

.quota-button:active {
  transform: translateY(1px);
}

.quota-code-input-btn {
  border: 1px solid rgba(221, 180, 99, 1);
  background: linear-gradient(
      39.27deg,
      rgba(188, 130, 58, 1) 0%,
      rgba(247, 207, 115, 1) 51.44%,
      rgba(227, 156, 24, 1) 100%
  );
}

</style>
